import React from 'react';
import styles from './Widgets.module.css';

const TopPerformer = () => {
  return (
    <div className={[styles['widget-container'], styles['top-performer']].join(' ')}>
      <div className={[styles['widget-header'], styles['white']].join(' ')}>
        <h3>Top Performer</h3>
      </div>
      <div className={styles['performer-content']}>
        <div className={styles['performer-avatar']}>
          <img src="https://ui-avatars.com/api/?name=Robert+K.+Vahn&background=1e293b&color=fff" alt="Performer" />
        </div>
        <div className={styles['performer-info']}>
          <h3 className={styles['performer-name']}>Robert K. Vahn</h3>
          <span className={styles['performer-role']}>Structural Team Lead</span>
        </div>
      </div>
      <div className={styles['performer-stats']}>
        <div className={styles['stat']}>
          <span className={styles['label']}>PROJECTS</span>
          <span className={styles['value']}>12</span>
        </div>
        <div className={styles['stat']}>
          <span className={styles['label']}>TASKS</span>
          <span className={styles['value']}>184</span>
        </div>
        <div className={styles['stat']}>
          <span className={styles['label']}>EFFICIENCY</span>
          <span className={styles['value']}>98%</span>
        </div>
      </div>
    </div>
  );
};

export default TopPerformer;
